<script>
/**
 * Type   : Biz component
 * Title  : 관리자 사이드바
 * Author : Aone Logistics
 * Date   : 2023-10-01
 * Version: 1.0.0
 * Description : 관리자 레이아웃 컴포넌트
 * 
 */
import PartnerInfoForm from './modal/PartnerInfoForm.vue'
import { workspaceServices, hasServiceAccess } from '@/utils/serviceWorkspace'

export default {
  name: "AdminSideBar",
  components: {
    PartnerInfoForm
  },
  props:{
    drawer : {
      type : Boolean,
      default : false
    },
    activeService: {
      type: String,
      default: 'logis'
    }
  },
  emits: ['quick-action', 'sign-out'],
  data(){
    return {
      session           : this.$store.getters.getLocalSession,
      isSignedIn        : this.$store.getters.getSessionStatus,
      memberId          : this.$store.getters.getLocalSession.memberId,
      authLevel         : '00',

      partnerModifyModalShow  : false,
      partnerModifyModalMode  : 'modify',
      accountMenuOpen         : false,

      partnerInfo       : {},
      workspaceServices,
      menuGroups        : [
        {
          id: 'logis-order',
          tab: 'logis',
          kind: 'section',
          title: 'Order 관리',
          icon: 'inbox',
          roles: ['admin', 'partner'],
          items: [
            { label: '통합조회', to: '/admin/parcel-info', roles: ['admin', 'partner'] },
            { label: '콘솔', to: '/admin/console', minAuth: 90, roles: ['admin'] },
            { label: '화물번호 대역폭관리', to: '/admin/hbl-no-manage', minAuth: 90, roles: ['admin'] },
            { label: 'HS CODE 관리', to: '/admin/hs-code-manage', minAuth: 90, roles: ['admin'] },
            { label: '파트너 오더 입고처리', to: '/admin/fulfillment/packing/receiving', minAuth: 90, roles: ['admin'], domain: 'logis' }
          ],
          addSeparator: true
        },
        {
          id: 'logis-packing',
          tab: 'fulfillment',
          kind: 'section',
          title: '포장 관리',
          icon: 'inventory_2',
          domain: 'fulfillment',
          roles: ['admin', 'partner'],
          minAuth: 80,
          items: [
            { label: '포장', to: '/admin/packing', minAuth: 80, roles: ['admin', 'partner'], domain: 'fulfillment' },
            { label: '익스프레스 규칙 관리', to: '/admin/fulfillment/packing/express-rules', minAuth: 90, roles: ['admin'], domain: 'fulfillment' }
          ],
          addSeparator: true
        },
        {
          id: 'logis-freight',
          tab: 'logis',
          kind: 'section',
          title: '화물운송편관리',
          icon: 'flight',
          minAuth: 90,
          roles: ['admin'],
          items: [
            { label: '운송편 관리', to: '/admin/freight-manage', minAuth: 90, roles: ['admin'] }
          ],
          addSeparator: true
        },
        {
          id: 'logis-schedule',
          tab: 'logis',
          kind: 'section',
          title: '일정관리',
          icon: 'date_range',
          minAuth: 80,
          roles: ['admin', 'partner'],
          domain: 'logis',
          items: [
            { label: '일정관리', to: '/admin/manage-schedule', minAuth: 80, roles: ['admin', 'partner'], domain: 'logis' }
          ],
          addSeparator: true
        },
        {
          id: 'logis-delivery',
          tab: 'logis',
          kind: 'section',
          title: '배송관리',
          icon: 'local_shipping',
          minAuth: 90,
          roles: ['admin'],
          items: [
            { label: '택배사관리', to: '/admin/courier-manage', minAuth: 90, roles: ['admin'] },
            { label: '픽업지관리', to: '/admin/pickup-manage', minAuth: 90, roles: ['admin'] }
          ],
          addSeparator: true
        },
        {
          id: 'fulfillment-product-admin',
          tab: 'fulfillment',
          kind: 'section',
          title: '상품 관리',
          icon: 'inventory',
          minAuth: 80,
          roles: ['admin'],
          items: [
            { label: '상품 운영 현황', to: '/admin/fulfillment/operations', minAuth: 80, roles: ['admin'] },
            { label: '요청/매핑 관리', to: '/admin/fulfillment/request-mappings', minAuth: 80, roles: ['admin'] },
            { label: '목록 조회', to: '/admin/fulfillment/master-skus', minAuth: 80, roles: ['admin'] },
            { label: '신규 등록', to: '/admin/fulfillment/products/register', minAuth: 80, roles: ['admin'] },
            { label: '브랜드/카테고리 관리', to: '/admin/fulfillment/master-data?tab=brand', minAuth: 80, roles: ['admin'] }
          ],
          addSeparator: true
        },
        {
          id: 'partner-fulfillment-product',
          tab: 'fulfillment',
          kind: 'section',
          title: '상품 관리',
          icon: 'inventory',
          minAuth: 80,
          roles: ['partner'],
          items: [
            { label: '내 상품 현황', to: '/admin/fulfillment/home', minAuth: 80, roles: ['partner'] },
            { label: '내 상품목록 관리', to: '/admin/fulfillment/sku-requests', minAuth: 80, roles: ['partner'] }
          ],
          addSeparator: true
        },
        {
          id: 'inventory-overview',
          tab: 'inventory',
          kind: 'section',
          title: '재고 관리',
          icon: 'warehouse',
          minAuth: 80,
          roles: ['admin', 'partner'],
          items: [
            { label: '재고 개요', to: '/admin/inventory', minAuth: 80, roles: ['admin', 'partner'] }
          ],
          addSeparator: true
        },
        {
          id: 'common-header',
          tab: 'common',
          kind: 'section',
          title: '공통',
          icon: 'widgets',
          roles: ['admin', 'partner'],
          items: []
        },
        {
          id: 'common-communication',
          tab: 'common',
          kind: 'section',
          title: '소통관리',
          icon: 'list',
          minAuth: 90,
          roles: ['admin'],
          items: [
            { label: '공지사항', to: '/admin/common/notice', minAuth: 90, roles: ['admin'] }
          ],
          addSeparator: true
        },
        {
          id: 'common-member',
          tab: 'common',
          kind: 'section',
          title: '회원 관리',
          icon: 'manage_accounts',
          minAuth: 90,
          roles: ['admin'],
          items: [
            { label: '회원 정보관리', to: '/admin/customer-manage', minAuth: 90, roles: ['admin'] },
            { label: '파트너사 정보관리', to: '/admin/partner-manage', minAuth: 90, roles: ['admin'] }
          ],
          addSeparator: true
        },
        {
          id: 'common-history',
          tab: 'common',
          kind: 'section',
          title: '감사 로그',
          icon: 'history',
          minAuth: 90,
          roles: ['admin'],
          items: [
            { label: '인증·접속 이력', to: '/admin/common/login-history-manage', minAuth: 90, roles: ['admin'] },
            { label: '사용자 활동 로그', to: '/admin/common/user-behavior-tracking', minAuth: 90, roles: ['admin'] }
          ],
          addSeparator: true
        },
        {
          id: 'system-admin',
          tab: 'common',
          kind: 'section',
          title: '시스템 관리',
          icon: 'settings',
          minAuth: 90,
          roles: ['admin'],
          items: [
            { label: '코드관리', to: '/admin/common/code-management', minAuth: 90, roles: ['admin'] },
            { label: '파일관리', to: '/admin/common/backup-management', minAuth: 90, roles: ['admin'] },
            { label: 'DB 스키마 스냅샷', to: '/admin/common/schema-snapshots', minAuth: 90, roles: ['admin'] },
            { label: '운영 샘플 데이터', to: '/admin/common/logis-sample-data', minAuth: 90, roles: ['admin'] }
          ],
          addSeparator: true
        },
        {
          id: 'beta-test',
          tab: 'common',
          kind: 'section',
          title: '베타 테스트',
          icon: 'build',
          authEq: 99,
          roles: ['admin'],
          items: [
            { label: '임시 기능 테스트', to: '/admin/lab', authEq: 99, roles: ['admin'] }
          ]
        },
      ]
    }
  },
  computed: {
    isAdmin() {
      return Number(this.session?.authLevel) >= 90
    },
    isPartner() {
      return Number(this.session?.authLevel) === 80
    },
    accountName() {
      return `${this.session?.lName || ''}${this.session?.fName || ''}`.trim() || this.session?.memberId || '사용자'
    },
    accountInitial() {
      return this.accountName.charAt(0).toUpperCase()
    },
    accountOrganization() {
      return this.session?.partner_name || 'AONE'
    },
    accountRoleLabel() {
      return this.isAdmin ? '관리자' : (this.isPartner ? '파트너' : '사용자')
    },
    activeServiceInfo() {
      return this.workspaceServices.find(service => service.key === this.activeService) || this.workspaceServices[0]
    },
    quickActions() {
      const isPartner = Number(this.session?.authLevel) === 80
      if (isPartner && !hasServiceAccess(this.session, this.activeService)) return []

      if (this.activeService === 'logis') {
        return [
          { label: 'ORDER 등록', icon: 'add', action: 'newParcel' },
          { label: '엑셀 등록', icon: 'upload_file', action: 'uploadExcel' },
          { label: 'ORDER 등록 QR', icon: 'qr_code', action: 'orderQr' },
          { label: '무게 계산기', icon: 'scale', action: 'calculator' }
        ]
      }
      if (this.activeService === 'fulfillment') {
        const target = Number(this.session?.authLevel) >= 90
          ? '/admin/fulfillment/products/register'
          : '/admin/fulfillment/request/new'
        return [{ label: '상품 요청 등록', icon: 'add_box', to: target }]
      }
      return []
    },
    menuBlocks() {
      const auth = Number(this.session?.authLevel ?? 0)
      const role = auth >= 90 ? 'admin' : (auth === 80 ? 'partner' : 'guest')
      const hasDomainAccess = (entryDomain) => {
        if (!entryDomain || entryDomain === 'both') return true
        if (role !== 'partner') return true
        return hasServiceAccess(this.session, entryDomain)
      }
      const isAuthorized = (entry) => {
        if (Array.isArray(entry?.roles) && entry.roles.length) {
          if (!entry.roles.includes(role)) return false
        }
        if (entry?.minAuth !== undefined && auth < Number(entry.minAuth)) return false
        if (entry?.authEq !== undefined && auth !== Number(entry.authEq)) return false
        if (!hasDomainAccess(entry?.domain)) return false
        return true
      }

      const blocks = []
      const canAccessActiveService = role !== 'partner' || hasServiceAccess(this.session, this.activeService)
      this.menuGroups.forEach((group) => {
        const tabMatch = group.tab === 'common' || group.tab === this.activeService
        if (!tabMatch) return
        if (group.tab !== 'common' && !canAccessActiveService) return
        if (!isAuthorized(group)) return

        const items = (group.items || []).filter(isAuthorized)
        const hasVisibleItems = items.length > 0
        const isHeaderOnly = group.kind === 'section' && (group.items || []).length === 0

        if (group.kind === 'section' && (hasVisibleItems || isHeaderOnly)) {
          blocks.push({
            type: 'section',
            title: group.title,
            icon: group.icon,
            isCommonHeader: group.id === 'common-header'
          })
        }

        if (group.kind === 'list' || hasVisibleItems) {
          items.forEach((item) => {
            blocks.push({
              type: 'item',
              label: item.label,
              to: item.to,
              action: item.action
            })
          })
        }

      })
      return blocks
    }
  },
  methods:{
    openPartnerAccount() {
      this.accountMenuOpen = false
      this.partnerModifyModalShow = true
    },
    requestSignOut() {
      this.accountMenuOpen = false
      this.$emit('sign-out')
    },
    handleQuickAction(action) {
      if (action?.to) {
        this.$router.push(action.to)
        return
      }
      this.$emit('quick-action', action?.action)
    },
    handleMenuAction(item) {
      if (item?.to) {
        this.$router.push(item.to)
        return
      }
      if (item?.action === 'openPartnerModal') {
        this.partnerModifyModalShow = true
      }
    },
    /**
     * Title        : 파트너사 정보조회
     * Status       : Actived
     * Description  : 파트너사 직원 자신의 파트너사 정보조회
     */
    async getPartnerInfo(){

      let config = {
        method  : "POST",
        url     : "/api/partner/getPartnerInfo",
        name    : "[ Axios / 파트너사 정보조회 ]"
      }

      await this.$http(config)
        .then(res => {
          this.$log.debug("/partner/getPartnerInfo 실행됨", res)

          if(res.status === 200){
            this.partnerInfo = res.data
          } else {
            alert(res.info.reason)
          }
      }).catch(res => {
        this.$log.debug("/admin/signOut 실패함 catch", res)
        alert(`${config.name} 발생했습니다.`)
      })
    },


    /**
     * Title        : Initialize
     * Status       : Actived
     * Description  : 관리자 / 파트너 화면 초기화
     */
    async init() {

      // 관리자 권한
      this.authLevel =  this.$getAuthLevel()

      // 관리자 페이지 이므로 관리자가 아닌 경우 일반사이트로 이동을 시킨다.
      const sess = JSON.parse(sessionStorage.getItem('vuexStore'))
      
      let sessionData = sess?.user
      if(sessionData !== undefined){
        // 관리자가 아닐 경우. 일반 사이트 페이지로 튕겨낸다.
        if(this.authLevel < 80){
          alert("관리자 또는 파트너가 아닙니다.")
          this.$router.push("/")
        } else {
          this.$log.debug("관리자입니다.")
        }
      } else {
        alert("오류가 발생했습니다. 다시 로그인 해주세요.")
        this.$router.push("/")
      }

      // 파트너사 직원일 경우 자신의 파트너사 정보를 불러온다.
      if(this.authLevel == 80){
        await this.getPartnerInfo()
      }

    }
  },
  mounted(){
    this.init()
  }
}
</script>

<template>

  <div class="sidebar-shell">
  <!-- Account Area -->
  <div class="sidebar-avatar">
    <q-item
      clickable
      v-ripple
      class="sidebar-account-toggle"
      :aria-expanded="accountMenuOpen ? 'true' : 'false'"
      @click="accountMenuOpen = !accountMenuOpen"
    >
      <q-item-section avatar>
        <q-avatar color="cyan-8" text-color="white" size="42px">
          {{ accountInitial }}
        </q-avatar>
      </q-item-section>
      <q-item-section>
        <q-item-label class="sidebar-title">{{ accountOrganization }}</q-item-label>
        <q-item-label caption class="sidebar-account-name">
          {{ accountName }} · {{ accountRoleLabel }}
        </q-item-label>
        <q-item-label caption class="sidebar-email">{{ session.email }}</q-item-label>
      </q-item-section>
      <q-item-section side>
        <q-icon :name="accountMenuOpen ? 'expand_less' : 'expand_more'" />
      </q-item-section>
    </q-item>

    <q-slide-transition>
      <q-list v-show="accountMenuOpen" dense class="sidebar-account-menu">
        <q-item v-if="isPartner" clickable v-ripple @click="openPartnerAccount">
          <q-item-section avatar><q-icon name="business" /></q-item-section>
          <q-item-section>파트너 정보관리</q-item-section>
        </q-item>
        <q-separator />
        <q-item clickable v-ripple class="sidebar-sign-out" @click="requestSignOut">
          <q-item-section avatar><q-icon name="logout" color="negative" /></q-item-section>
          <q-item-section>로그아웃</q-item-section>
        </q-item>
      </q-list>
    </q-slide-transition>
  </div>

  <q-scroll-area
    ref="scroll-area"
    class="sidebar-scroll">

    <q-list class="list-background">


      <div class="workspace-summary q-pa-md">
        <div class="row items-center no-wrap">
          <q-icon :name="activeServiceInfo.icon" color="cyan-9" size="28px" class="q-mr-sm" />
          <div>
            <div class="text-weight-bold">{{ activeServiceInfo.title }}</div>
            <div class="text-caption text-grey-7">{{ activeServiceInfo.description }}</div>
          </div>
        </div>
      </div>

      <div v-if="quickActions.length" class="q-px-sm q-pb-sm">
        <div class="text-caption text-weight-bold text-grey-7 q-px-sm q-pb-xs">빠른 실행</div>
        <q-btn
          v-for="action in quickActions"
          :key="action.label"
          flat
          no-caps
          align="left"
          color="cyan-9"
          class="full-width quick-action-button"
          :icon="action.icon"
          :label="action.label"
          @click="handleQuickAction(action)"
        />
      </div>
      <template v-for="(block, idx) in menuBlocks" :key="`${block.type}-${idx}`">
        <q-item
          v-if="block.type === 'section'"
          v-ripple
          class="class-divider"
          :class="{ 'sidebar-common-break': block.isCommonHeader }"
        >
          <q-item-section avatar>
            <q-icon :name="block.icon" />
          </q-item-section>
          <q-item-section>
            {{ block.title }}
          </q-item-section>
        </q-item>

        <q-item
          v-else-if="block.type === 'item'"
          clickable
          v-ripple
          :active="Boolean(block.to) && $route.path === block.to"
          active-class="sidebar-item-active"
          @click="handleMenuAction(block)"
        >
          <q-item-section>
            {{ block.label }}
          </q-item-section>
        </q-item>

      </template>

    </q-list>
  </q-scroll-area>
  </div>


  <!-- 파트너사 수정 모달 -->
  <teleport to="body">
    <q-dialog 
      v-model="partnerModifyModalShow">

      <PartnerInfoForm 
        :partnerInfo="partnerInfo"
        :authLevel="authLevel"
        :mode="partnerModifyModalMode" />
    
    </q-dialog>
  </teleport>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .class-divider {
    background-color: #d7d7d7;
    color: #111;
    border-left: 4px solid #1e88e5;
    letter-spacing: 0.2px;
  }

  .sidebar-common-break {
    margin-top: 12px;
    padding-top: 8px;
    background-color: #1e88e5;
    color: #fff;
  }

  .sidebar-avatar {
    background: #f3f6f8;
    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.08);
  }

  .sidebar-shell {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-right: 1px solid #ddd;
  }

  .sidebar-scroll {
    flex: 1 1 auto;
    min-height: 0;
  }

  .sidebar-account-toggle {
    min-height: 82px;
    padding: 12px;
  }

  .sidebar-account-toggle :deep(.q-item__section--avatar) {
    min-width: 50px;
  }

  .sidebar-title,
  .sidebar-account-name,
  .sidebar-email {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sidebar-title {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.2px;
  }

  .sidebar-account-name {
    color: #334155;
    margin-top: 2px;
  }

  .sidebar-email {
    font-size: 11px;
    color: #64748b;
  }

  .sidebar-account-menu {
    padding: 4px 0;
    background: #fff;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }

  .sidebar-account-menu .q-item {
    min-height: 40px;
  }

  .sidebar-account-menu :deep(.q-item__section--avatar) {
    min-width: 42px;
  }

  .sidebar-sign-out {
    color: #475569;
  }

  .workspace-summary {
    border-bottom: 1px solid #e0e0e0;
    background: #f8fafb;
  }

  .quick-action-button {
    min-height: 38px;
    justify-content: flex-start;
  }

  .list-background .q-item:not(.class-divider) {
    padding-left: 18px;
  }

  .list-background .q-item:not(.class-divider) .q-item-section {
    padding-left: 6px;
  }

</style>
